import React, { useState } from 'react';
import { 
  Row, 
  Col, 
  FormGroup, 
  InputGroup, 
  InputGroupText, 
  Input, 
  Button, 
  Container, 
  Card, 
  CardHeader, 
  CardTitle, 
  CardBody 
} from 'reactstrap';

const PreFooter = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  return (
    <div id="prefooter" className="subscribe-line">
      <Container>
        <Row>
          <Col className="mx-auto" lg="8" xs="10">
            <Card className="card-raised card-form-horizontal bg-default rounded">
              <CardBody>
                <Row>
                  <Col sm="12">
                    <form name="contact" method="post">
                    <input type="hidden" name="form-name" value="contact" />
                      <Row>
                        <Col sm="12">
                          <div className="p-3">
                            <CardHeader className="text-center font-weight-bold bg-default">
                              <CardTitle tag="h4" className="text-white">Send us a message</CardTitle>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col md="6">
                                  <FormGroup>
                                    <InputGroup>
                                      <InputGroupText>
                                        <i className="ni ni-circle-08"></i>
                                      </InputGroupText>
                                      <Input
                                        name="firstName"
                                        placeholder="First Name..."
                                        type="text"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                      />
                                    </InputGroup>
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup>
                                    <InputGroup>
                                      <InputGroupText>
                                        <i className="ni ni-collection"></i>
                                      </InputGroupText>
                                      <Input
                                        name="lastName"
                                        placeholder="Last Name..."
                                        type="text"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                      />
                                    </InputGroup>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <FormGroup>
                                <InputGroup>
                                  <InputGroupText>
                                    <i className="ni ni-email-83"></i>
                                  </InputGroupText>
                                  <Input
                                    name="email"
                                    placeholder="Email Here..."
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                  />
                                </InputGroup>
                              </FormGroup>
                              <FormGroup>
                                <Input
                                  name="message"
                                  placeholder="Your message..."
                                  type="textarea"
                                  rows="6"
                                  value={formData.message}
                                  onChange={handleChange}
                                  required
                                />
                              </FormGroup>
                              <Row>
                                <Col md="6">
                                  <div className="custom-control custom-checkbox mb-3">
                                    <input
                                      className="custom-control-input"
                                      id="customCheck2"
                                      type="checkbox"
                                      required
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customCheck2"
                                    >
                                      <span className="text-white">I'm not a robot</span>
                                    </label>
                                  </div>
                                </Col>
                                <Col md="6">
                                  <Button
                                    className="pull-right"
                                    color="info"
                                    type="submit"
                                  >
                                    Send Message
                                  </Button>
                                </Col>
                              </Row>
                            </CardBody>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PreFooter;
